/* Packages */
import React, {useEffect, useState, useRef} from 'react';
import {createPortal} from 'react-dom';
import {motion, useAnimation, AnimatePresence} from 'framer-motion';

/* Helpers */
import {slideIn, circInOut} from '../favorites/lib/animations';

export default function ItemNotification({
    domNode,
    items,
    NotificationComponent = null,
    dismissable = false,
    autoDismissable = false,
    showNotificationThreshold = 2,
    showNotificationOnPageLoad = true,
    ...rest
}) {
    /* State */
    const [showNotification, setShowNotification] = useState(false);
    const [shouldShowNotification, setShouldShowNotification] = useState(showNotificationOnPageLoad);

    /* Refs */
    const autoDismisableTimeOut = useRef(false); //now you can pass timer to another component

    /* Animation values */
    const onItemUpdate = useAnimation();

    /* Effects */
    useEffect(() => {
        setShowNotification(shouldShowNotification && items.length >= showNotificationThreshold);
        setShouldShowNotification(true);

        if (!autoDismissable) return;

        clearTimeout(autoDismisableTimeOut.current);
        autoDismisableTimeOut.current = setTimeout(() => setShowNotification(false), autoDismissable);

        return () => {
            clearTimeout(autoDismisableTimeOut.current);
        };

    }, [items]);

    useEffect(() => {
        /* Animate every time items.length > 2 updates */
        if (items.length >= showNotificationThreshold) {
            onItemUpdate.start({
                y: [0, -30, 0],
                transition: {
                    ...circInOut,
                },
            });
        }
    }, [items.length]);

    /* Render */
    return createPortal(
        <AnimatePresence>
            {showNotification && (
                <motion.div className="toast" {...slideIn}>
                    <motion.article
                        className="toast__wrapper d-flex flex-row-reverse flex-lg-column"
                        animate={onItemUpdate}>
                        {NotificationComponent &&
                            <NotificationComponent
                                items={items}
                                dismissable={dismissable}
                                setShowNotification={setShowNotification}
                                {...rest}
                            />
                        }
                    </motion.article>
                </motion.div>
            )}
        </AnimatePresence>,
        domNode
    );
}

